import * as classnames from "classnames";
import { isEqual } from "lodash";
import * as React from "react";

import { Modal, Msg } from "../../../../shared/components";
import { ChallengeTakenBy } from "../../../../shared/services/enums";

/**
 * Prop interface
 */
export interface SwitchTakenByProps {
  isOpen: boolean;
  takenBy: ChallengeTakenBy;
  onSwitch?: () => void;
  onCancel?: () => void;
}

/**
 * Page component
 */
class SwitchTakenBy extends React.Component<SwitchTakenByProps> {
  constructor(props: SwitchTakenByProps) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: SwitchTakenByProps) {
    return !isEqual(nextProps, this.props);
  }

  public render() {
    const { isOpen, onCancel, onSwitch, takenBy } = this.props;

    const rootStyle = classnames("code-switch-taken-by");

    return (
      <Modal
        className={rootStyle}
        title={<Msg id={"switch-taken-by.title"} />}
        isOpen={isOpen}
        onClose={onCancel}
        onClickCancel={onCancel}
        onClickOk={onSwitch}
        okButtonLabel={
          <Msg
            id={
              takenBy === ChallengeTakenBy.LocalMachine
                ? "start-challenge.button.local"
                : "start-challenge.button.web"
            }
          />
        }
        okButtonAriaLabel="Switch"
        ariaLabel="Switch Taken By"
      >
        <Msg id={"switch-taken-by.body"} />
      </Modal>
    );
  }
}

export default SwitchTakenBy;
